module.exports = __webpack_public_path__ + "static/media/FILM.abd5f393.png";